<template>
  <div id="app">
    <DeviseModal v-if="lang == 'pt'" />
    <DeviseModalEs v-else />
    <TermsOfUseModal />
    <ModalIframe />

    <MainHeader v-if="isNotInConfig" />

    <div class="container-fluid" :class="backgroundColor">
      <router-view />
    </div>

  </div>
</template>

<script>
import MainHeader from "./components/structure/MainHeader.vue";
import DeviseModal from "./components/devise/Modal.vue";
import DeviseModalEs from "./components/devise/ModalEs.vue";
import TermsOfUseModal from "./components/devise/TermsOfUse.vue";
import ModalIframe from "./components/ModalIframe.vue";

export default {
  name: 'app',

  data() {
    return {
      backgroundColor: ''
    }
  },

  computed: {
    isNotInConfig(){
      if(
        this.$route.name == 'capa-teste' ||
        this.$route.name == 'teste'
       ){
        return false;
      }else{
        return true;
      }
    },

    lang(){
      return localStorage.getItem('lang') || 'pt';
    }
  },

  components: {
    MainHeader,
    DeviseModal,
    DeviseModalEs,
    TermsOfUseModal,
    ModalIframe
  },

  watch: {
    '$route.name': function(newRoute, oldRoute){
      this.setBackground(newRoute);
    }
  },

  created() {
    // Se o id do primeiro estado não for um inteiro, quer dizer que está usando uma listagem de estados antiga, então devemos zerar para poder usar a nova
    let oldStates = localStorage.getItem('states');
    if(oldStates){
      if(isNaN(JSON.parse(oldStates)[0]['id'])){
        localStorage.removeItem('states')
      }
    }
    this.$store.dispatch("domains/getLocalDomains");
    this.$store.dispatch("location/setUserLocation", this.$geoip2);
    this.$store.dispatch("location/setStates");
    this.$store.dispatch("user/checkAuth");
    this.$EventBus.$on('checkTermsOfUse', () => {
      this.termsOfUse();
    });
    this.termsOfUse();
    this.hasSource();
  },

  destroyed() {
    this.$EventBus.$off('checkTermsOfUse');
  },

  methods: {
    setBackground(newRoute = null){
      let routeName = newRoute || this.$route.name;
      if(routeName == 'meu-perfil' || routeName == 'deixe-seu-perfil' || routeName == 'ficha' || routeName == 'testes' || routeName == 'capa-teste' || routeName == 'teste'){
        this.backgroundColor = ''
      }else{
        this.backgroundColor = ''
      }
    },

    termsOfUse(){
      if( this.$store.state.user.profile &&
          localStorage.getItem('termsOfUseAccepted') &&
          localStorage.getItem('termsOfUseAccepted') == 'false'
      ){
        setTimeout(() => this.$EventBus.$emit('showTermsOfUse'), 50)
      }
    },

    hasSource(){
      if(this.$route.query.source){
        localStorage.setItem('source', this.$route.query.source);
      }
    }
  },
};
</script>

<style lang="scss">
  @import "./assets/stylesheets/app.scss";
  #app{
    & > .container-fluid {
      min-height: 80vh;
    }
  }
</style>